import { useState, useEffect } from "react";
import { Package } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Alpine Armour Logo component with dynamic branding support
 * Fetches logo from API, falls back to Package icon if not available
 */
export function Logo({ 
  size = "md", // "sm" | "md" | "lg" | "xl"
  showText = true,
  className = "" 
}) {
  const [logoUrl, setLogoUrl] = useState(null);
  const [imageError, setImageError] = useState(false);
  
  useEffect(() => {
    const loadBranding = async () => {
      try {
        const res = await axios.get(`${API}/branding`);
        if (res.data.header_logo) {
          setLogoUrl(res.data.header_logo);
        }
      } catch (error) {
        // Fallback to static file
        setLogoUrl("/logo.png");
      }
    };
    loadBranding();
  }, []);
  
  const sizeConfig = {
    sm: { container: "w-7 h-7", icon: "w-3.5 h-3.5", text: "text-base", img: "h-7" },
    md: { container: "w-8 h-8", icon: "w-4 h-4", text: "text-lg", img: "h-8" },
    lg: { container: "w-12 h-12", icon: "w-6 h-6", text: "text-xl", img: "h-12" },
    xl: { container: "w-20 h-20", icon: "w-10 h-10", text: "text-2xl", img: "h-20" },
  };
  
  const config = sizeConfig[size] || sizeConfig.md;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {logoUrl && !imageError ? (
        <img 
          src={logoUrl} 
          alt="Alpine Armour"
          className={`${config.img} object-contain`}
          onError={() => setImageError(true)}
        />
      ) : (
        <div className={`${config.container} bg-primary rounded-lg flex items-center justify-center shrink-0`}>
          <Package className={`${config.icon} text-primary-foreground`} />
        </div>
      )}
      {showText && (
        <span className={`font-bold tracking-tight ${config.text}`}>Alpine Armour</span>
      )}
    </div>
  );
}

/**
 * Full-size logo for login page
 */
export function LogoFull({ className = "" }) {
  const [logoUrl, setLogoUrl] = useState(null);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const loadBranding = async () => {
      try {
        const res = await axios.get(`${API}/branding`);
        if (res.data.header_logo) {
          setLogoUrl(res.data.header_logo);
        }
      } catch (error) {
        // Fallback to static file
        setLogoUrl("/logo.png");
      }
    };
    loadBranding();
  }, []);

  return (
    <div className={`flex flex-col items-center gap-4 ${className}`}>
      {logoUrl && !imageError ? (
        <img 
          src={logoUrl} 
          alt="Alpine Armour"
          className="h-24 w-auto object-contain"
          onError={() => setImageError(true)}
        />
      ) : (
        <div className="w-20 h-20 bg-primary rounded-xl flex items-center justify-center">
          <Package className="w-10 h-10 text-primary-foreground" />
        </div>
      )}
      <div className="text-center">
        <h1 className="text-2xl font-bold">Alpine Armour Production</h1>
        <p className="text-muted-foreground text-sm">Login to continue</p>
      </div>
    </div>
  );
}

export default Logo;
